import { useQuery } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Faq } from "../../types/Faq";

export const getFaq = (faqId: string, options: APQueryOptions = {}) => {
  const { fetchWithAuth } = useApi();
  const { isQueryEnabled } = useAPQuery();

  return useQuery({
    queryKey: ["faqs", faqId],
    queryFn: (): Promise<Faq> => {
      return fetchWithAuth<Faq>("getFaq", faqId);
    },
    enabled: isQueryEnabled(options),
  });
};
